'use client';

import Image from 'next/image';
import { ConsentText } from '@/features/consent';

type Props = {
    placeholderImageUrl?: string;
    placeholderImageAlt?: string;
    consentText: string;
    consentButtonText: string;
    privacyPageSlug?: string;
    onAccept: () => void;
};

export function ConsentOverlay({
    placeholderImageUrl,
    placeholderImageAlt,
    consentText,
    consentButtonText,
    privacyPageSlug,
    onAccept,
}: Props) {
    return (
        <div className="absolute inset-0 w-full h-full overflow-hidden bg-neutral-900 rounded-md">
            {placeholderImageUrl && (
                <Image
                    src={placeholderImageUrl}
                    alt={placeholderImageAlt ?? ''}
                    fill
                    sizes="(max-width: 1024px) 100vw, 1280px"
                    className="object-cover blur-sm"
                />
            )}
            <div className="absolute inset-0 bg-gray-800/75" aria-hidden="true" />
            <div className="absolute inset-0 flex flex-col h-full items-center sm:justify-center gap-4 p-6 text-center text-white overflow-auto">
                <Image
                    src="/images/youtube-button.png"
                    alt=""
                    width={68}
                    height={52}
                    className="w-10.75 md:w-17 h-auto"
                />
                <p className="text-sm whitespace-pre-line mb-2">
                    <ConsentText text={consentText} privacyPageSlug={privacyPageSlug} />
                </p>
                <button type="button" onClick={onAccept} className="btn btn-primary">
                    {consentButtonText}
                </button>
            </div>
        </div>
    );
}
